import chart from '../PositiveNegativeBarChartSmall/alt_chart';
import PDFMakeChartConverter from './PDFMakeChartConverter';

export default async (node_data) => {
  const chartConvertor = new PDFMakeChartConverter(chart);

  const options = {
    chartOptions: {
      veryPositiveColour: '#7ec99e',
      positiveColour: '#87d3d3',
      neutralColour: '#CCC',
      negativeColour: '#ffdc5d',
      veryNegativeColour: '#f27a7c',
      animate: false,
      isTextThemeTable: true,
    },
    defaultStyle: {
      fontSize: 12,
      font: 'Open Sans',
    },
  };

  return chartConvertor.convert(node_data, options);
};
